import React, { useState } from "react";
import { Link } from "react-router";
import { Button } from "reactstrap";
import ImgManaged from "../../../../components/common/img-managed";
import { getBookUrl, uniqBy, getDownloadUrl } from "../../../../common/util";
import BookLocales from "./book-locales";
import "./style.css";

import { useTranslation } from "react-i18next";

const BookCard = (props) => {
  const { t } = useTranslation();
  const bookTypes = ["Pdf", "Epub"];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const image = process.env.REACT_APP_API_URL + props.book.coverUrl;

  const addBook = (book) => {
    props.addBookToCart(book);
  };

  function toggle() {
    setDropdownOpen(!dropdownOpen);
  }

  function modaltoggle(book) {
    let url = process.env.REACT_APP_API_URL + book.audioUrl;
    props.playAudio({
      url,
      title: book.title,
      author: renderAuthors(book.authors),
    });
  }

  function handlePlayAll(articles) {
    const tracks = articles.map((article) => ({
      url: process.env.REACT_APP_API_URL + (article.audioUrl || article.audiourl),
      title: article.title,
      author: article.author.name,
    }));
    props.playAll(tracks);
  }

  function renderAuthors(authors) {
    const uniq = uniqBy(authors, JSON.stringify);
    const result = uniq.map((a) => a.name);
    return result.join(", ");
  }

  function renderBookTypes(book) {
    const availableBookTypes = bookTypes.filter(
      (bookType) => book[bookType.toLowerCase() + "Url"]
    );
    return availableBookTypes.map((bookType, i) => {
      const faName = bookType === "Epub" ? "fa-book" : "fa-file-pdf-o";
      return (
        <Button
          key={i}
          tag="a"
          href={getDownloadUrl(book.code, bookType.toLowerCase())}
          className="btn btn-light"
          target="_blank"
          rel="noopener"
        >
          <i className={"fa " + faName + " fa-3"} aria-hidden="true"></i>
          <span className="ps-2">{bookType}</span>
        </Button>
      );
    });
  }

  const book = props.book;
  const viewMode = props.mode;

  const bookHasAudioArticles = book?.articles?.some(b=>b.audioUrl);

  const fgbStringText = (function (b) {
    switch (b) {
      case "EN":
        return "FGB";
      case "ES":
        return "Portavoz";
      case "FR":
        return "FGB";
      default:
        return "FGB";
    }
  })(book.language);

  const fgbString = !!book.number
    ? fgbStringText + " " + book.number + " - "
    : "";
console.log(book.articles)
  return (
    <div
      className={
        (viewMode === "list"
          ? "book-title-container-tiny"
          : "book-title-container") + ""
      }
    >
      <Link to={getBookUrl(book)} style={{ textDecoration: "none" }}>
        <div className="book-image-box">
          <ImgManaged
            src={image}
            type={book.type}
            width={100}
            height={"auto"}
            alt={book.title}
            style={"shadow"}
          />
        </div>
      </Link>
      <div className="p-2">
        <Link to={getBookUrl(book)} style={{ textDecoration: "none" }}>
          <div className="title-description">
            <p>{fgbString + book.title}</p>
          </div>
        </Link>
        <div className="d-flex d-row justify-content-between">
          <div>
            <p className="authors">{renderAuthors(book.authors)}</p>
          </div>
          {BookLocales(book, t)}
        </div>
      </div>

      <div className="d-flex flex-row button-container">
        {renderBookTypes(book)}
        {book.epubUrl && (
          <Link to={`/read/${book.code}`} className="btn btn-light">
            <i className="fa fa-desktop" aria-hidden="true"></i>
          </Link>
        )}
        {(book.audioUrl || bookHasAudioArticles) && (
          <Button
            tag="a"
            className="btn btn-light"
            onClick={(e) => {
              e.preventDefault();
              if (bookHasAudioArticles) {
                handlePlayAll(book.articles);
              } else {
                modaltoggle(book);
              }
            }}
          >
            <i className="fa fas fa-volume-up" aria-hidden="true"></i>
          </Button>
        )}
        {book.hasPrintableVersion && (
          <Button className="btn btn-light" onClick={() => addBook(book)}>
            <i className="fa fas fa-shopping-cart" aria-hidden="true"></i>
          </Button>
        )}
      </div>
    </div>
  );
};

export default BookCard;
